import { render, staticRenderFns } from "./transfer-confirm-dialog.vue?vue&type=template&id=4de55ca1&scoped=true"
import script from "./transfer-confirm-dialog.vue?vue&type=script&lang=js"
export * from "./transfer-confirm-dialog.vue?vue&type=script&lang=js"
import style0 from "./transfer-confirm-dialog.vue?vue&type=style&index=0&id=4de55ca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de55ca1",
  null
  
)

export default component.exports